<template>
  <div>
    <the-nav-bar ref="navbar" />
    <md-field :brief="$t('payInfo.personalInfo')" class="body-wrapper">
      <md-input-item
        v-if="isTrueNameEdit"
        :title="$t('payInfo.trueName')"
        type="text"
        align="right"
        v-model.trim="name"
      ></md-input-item>
      <md-field-item
        :title="$t('payInfo.trueName')"
        :content="name"
        v-else
      ></md-field-item>
      <template v-if="currentPayMethod == 'bank'">
        <md-input-item
          :title="$t('payInfo.bankAccount')"
          align="right"
          v-model="bank.account"
          type="bankCard"
        ></md-input-item>
        <md-input-item
          :title="$t('payInfo.bankName')"
          align="right"
          type="text"
          v-model.trim="bank.address1"
        ></md-input-item>
        <md-input-item
          :title="$t('payInfo.openingBank')"
          align="right"
          type="text"
          v-model.trim="bank.address2"
        ></md-input-item>
      </template>
      <template v-else-if="currentPayMethod == 'alipay'">
        <md-input-item
          name="alipay"
          type="text"
          v-model.trim="alipay.account"
          @change="onValidate"
          :title="$t('payInfo.alipayAccount')"
          align="right"
          :error="alipayErr"
        ></md-input-item>
        <md-field-item :title="$t('payInfo.qr')" class="upload">
          <div class="upload-content row-center">
            <md-image-reader
              name="alipay"
              @select="onReaderSelect"
              @complete="onReaderComplete"
              @error="onReaderError"
            ></md-image-reader>
            <img class="preview-img" v-if="alipay.qr" :src="alipay.qr" />
            <div class="col-center" v-else>
              <svg class="icon"><use xlink:href="#icon-upload" /></svg>
              <span class="text">{{ $t('payInfo.upload') }}</span>
            </div>
          </div>
        </md-field-item>
      </template>
      <template v-else-if="currentPayMethod == 'wechatpay'">
        <md-input-item
          name="wechatpay"
          type="text"
          v-model.trim="wechatpay.account"
          @change="onValidate"
          :title="$t('payInfo.wechatAccount')"
          align="right"
          :error="wechatpayErr"
        ></md-input-item>
        <md-field-item :title="$t('payInfo.qr')" class="upload">
          <div class="upload-content row-center">
            <md-image-reader
              name="wechatpay"
              @select="onReaderSelect"
              @complete="onReaderComplete"
              @error="onReaderError"
            ></md-image-reader>
            <img class="preview-img" v-if="wechatpay.qr" :src="wechatpay.qr" />
            <div class="col-center" v-else>
              <svg class="icon"><use xlink:href="#icon-upload" /></svg>
              <span class="text">{{ $t('payInfo.upload') }}</span>
            </div>
          </div>
        </md-field-item>
      </template>
      <div class="field-footer" slot="footer">
        <div class="info">
          {{ $t('payInfo.uploadInfo') }}
        </div>
        <div class="btn-wrapper">
          <md-button
            :type="btnDisabled ? 'disabled' : 'primary'"
            @click="onSubmit"
          >
            <md-activity-indicator
              v-if="isSubmitting"
              type="carousel"
              color="currentColor"
            ></md-activity-indicator>
            <span v-else>{{ $t('common.submit') }}</span>
          </md-button>
          <md-button
            v-if="id"
            :type="isRemoving ? 'disabled' : 'primary'"
            plain
            @click="onDelete"
          >
            <md-activity-indicator
              type="carousel"
              color="currentColor"
              v-if="isRemoving"
            />
            <span v-else>{{ $t('common.remove') }}</span>
          </md-button>
        </div>
      </div>
    </md-field>
  </div>
</template>

<script>
import TheNavBar from '@/components/the-nav-bar';
import {
  Field,
  FieldItem,
  InputItem,
  Button,
  ImageReader,
  Toast,
  ActivityIndicator,
  Dialog,
} from 'mand-mobile';
import imageProcessor from 'mand-mobile/components/image-reader/image-processor';
import { mapState } from 'vuex';
import { postAddPayInfo, putPayInfo, deletePayInfo } from '@/api/user';
export default {
  components: {
    TheNavBar,
    [Field.name]: Field,
    [FieldItem.name]: FieldItem,
    [InputItem.name]: InputItem,
    [Button.name]: Button,
    [ImageReader.name]: ImageReader,
    [ActivityIndicator.name]: ActivityIndicator,
  },
  data() {
    return {
      name: '',
      bank: {
        account: '',
        address1: '',
        address2: '',
      },
      alipay: {
        account: '',
        qr: '',
      },
      wechatpay: {
        account: '',
        qr: '',
      },
      isSubmitting: false,
      isRemoving: false,
      alipayErr: '',
      wechatpayErr: '',
    };
  },
  computed: {
    ...mapState(['userInfo', 'payInfoList']),
    currentPayMethod() {
      return this.$route.query.payMethod;
    },
    isAdd() {
      return !!this.$route.query.isAdd;
    },
    isTrueNameEdit() {
      return (this.userInfo.isMerchant);
    },
    id() {
      const { id } = this.$route.query;
      return id ? id : null;
    },
    btnDisabled() {
      switch (this.currentPayMethod) {
        case 'bank':
          return (
            !this.name ||
            !this.bank.account ||
            !this.bank.address1 ||
            this.isSubmitting
          );
        case 'wechatpay':
          return (
            !this.name ||
            !this.wechatpay.account ||
            this.isSubmitting ||
            this.wechatpayErr
          );
        case 'alipay':
          return (
            !this.name ||
            !this.alipay.account ||
            this.isSubmitting ||
            this.alipayErr
          );
        default:
          return false;
      }
    },
  },
  created() {
    if (this.id) {
      const target = this.payInfoList.find(item => item.id == this.id);
      if (!target) {
        this.$router.go(-1);
      } else {
        this.name = target.trueName;
        this.copy(this[this.currentPayMethod], target);
      }
    }else{
      if(this.userInfo.trueName){
        this.name = this.userInfo.trueName;
      }
    }
  },
  methods: {
    onReaderSelect() {
      Toast.loading('loading...');
    },
    onReaderComplete(name, { dataUrl }) {
      imageProcessor({ dataUrl, width: 768, quality: 1 })
        .then(({ dataUrl }) => {
          Toast.hide();
          if (dataUrl) {
            this[name].qr = dataUrl;
          }
        })
        .catch(err => {
          Toast.failed(err.message);
        });
    },
    onReaderError(name, err) {
      Toast.failed(err.message);
    },
    onSubmit() {
      this.isSubmitting = true;
      let params = {
        truename: this.name,
        symbol: this.currentPayMethod,
      };
      switch (this.currentPayMethod) {
        case 'wechatpay':
          params.account = this.wechatpay.account;
          if (this.wechatpay.qr) {
            params.qr = this.wechatpay.qr;
          }
          break;
        case 'alipay':
          params.account = this.alipay.account;
          if (this.alipay.qr) {
            params.qr = this.alipay.qr;
          }
          break;
        case 'bank':
          params.account = this.bank.account;
          params.name = this.bank.address1;
          params.address = this.bank.address2;
          break;
      }
      if (this.id) {
        putPayInfo(this.id, params)
          .then(() => {
            this.$router.go(-1);
            this.isSubmitting = false;
          })
          .catch(err => {
            this.isSubmitting = false;
            Dialog.alert({
              icon: 'fail',
              title: this.$t('error.occurs'),
              content: err.message,
              confirmText: this.$t('common.confirm'),
            });
          });
      } else {
        postAddPayInfo(params)
          .then(() => {
            if (this.isAdd) {
              window.localStorage.setItem('needBack', 1);
            }
            this.$router.go(-1);
            this.isSubmitting = false;
          })
          .catch(err => {
            this.isSubmitting = false;
            Dialog.alert({
              icon: 'fail',
              title: this.$t('error.occurs'),
              content: err.message,
              confirmText: this.$t('common.confirm'),
            });
          });
      }
    },
    onDelete() {
      Dialog.confirm({
        icon: 'warn',
        title: this.$t('payInfo.deleteAlert'),
        cancelText: this.$t('common.cancel'),
        confirmText: this.$t('common.confirm'),
        onConfirm: () => {
          this.isRemoving = true;
          deletePayInfo(this.id)
            .then(() => {
              Toast.succeed(this.$t('payInfo.removeSuccess'));
              this.isRemoving = false;
              this.$store.commit('removePayInfoItem', this.id);
              this.$router.go(-1);
            })
            .catch(err => {
              this.isRemoving = false;
              Dialog.alert({
                icon: 'fail',
                title: this.$t('error.occurs'),
                content: err.message,
                confirmText: this.$t('common.confirm'),
              });
            });
        },
      });
    },
    onValidate(name, value) {
      this.alipayErr = '';
      this.wechatpayErr = '';
      switch (name) {
        case 'alipay':
          if (value !== '' && !/\S*$/.test(value)) {
            this.alipayErr = this.$t('payInfo.incorrect', {
              name: this.$t('payInfo.alipayAccount'),
            });
          }
          break;
        case 'wechatpay':
          if (
            value !== '' &&
            !/^[a-zA-Z]{1}[-_a-zA-Z0-9]{5,19}$/.test(value) &&
            !/^\d*$/.test(value)
          ) {
            this.wechatpayErr = this.$t('payInfo.incorrect', {
              name: this.$t('payInfo.wechatAccount'),
            });
          }
          break;
        default:
      }
    },
    copy(source, target) {
      Object.entries(source).forEach(([key]) => {
        source[key] = target[key];
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
.body-wrapper {
  padding-bottom: 20vw;

  .md-field-item {
    margin-bottom: 3.2vw;
  }

  & >>> {
    .md-field-item-content {
      height: 17.07vw;

      &:before {
        content: none;
      }
    }

    .md-field-item-title {
      width: 32vw;
      font-size: 3.73vw;
      font-weight: bold;
    }

    .md-field-item-control {
      width: 53.6vw;
      text-align: right;
    }

    .md-input-item-input {
      border: 0.27vw solid #eaf1f3;
      border-radius: 2.67vw;
      padding: 0 2.67vw;
      background: #f8fbfc;
    }

    .md-field-item-children {
      position: absolute;
      right: 0;
      top: 100%;
      z-index: 10;
      margin-top: 0;
    }
  }

  .upload {
    & >>> {
      .md-field-item-content {
        height: auto;
        align-items: flex-start;
      }

      .md-field-item-title {
        margin-top: 5.33vw;
        width: 40vw;
      }

      .md-field-item-control {
        width: 40vw;
        flex: 0 0 auto;
      }
    }

    .upload-content {
      position: relative;
      box-sizing: border-box;
      margin-top: 2.67vw;
      border: 0.27vw solid #eaf1f3;
      border-radius: 2.67vw;
      height: 40vw;
      background: #f8fbfc;
      color: #BCC7CB;
      overflow: hidden;

      .preview-img {
        width: 100%;
        line-height: 40vw;
        vertical-align: middle;
      }

      .icon {
        width: 14vw;
        height: 14vw;
      }
    }
  }

  .info {
    margin-top: 4.8vw;
    color: #84969c;
  }

  .btn-wrapper {
    margin-top: 9.6vw;

    .md-button {
      margin-bottom: 4.8vw;
    }

    & >>> .md-activity-indicator-svg {
      width: 16vw !important;
      height: 4vw !important;
    }
  }
}
</style>
